export const trustSignals = [{
  id: 'app-count',
  stats: '8,000 +',
  label: 'Number of apps',
  cardStyles: {
    backgroundColor: "var(--ds-surface-raised)",
    border: "1px solid ".concat("var(--ds-border-accent-magenta)"),
    slabColor: "var(--ds-border-accent-magenta)"
  },
  statsStyles: {
    color: "var(--ds-text-accent-magenta)"
  }
}, {
  id: 'install-count',
  stats: '1.2M +',
  label: 'Number of installs',
  cardStyles: {
    backgroundColor: "var(--ds-surface-raised)",
    border: "1px solid ".concat("var(--ds-border-accent-lime)"),
    slabColor: "var(--ds-border-accent-lime)"
  },
  statsStyles: {
    color: "var(--ds-text-accent-lime)"
  }
}, {
  id: 'partner-count',
  stats: '1,800 +',
  label: 'Number of partners',
  cardStyles: {
    backgroundColor: "var(--ds-surface-raised)",
    border: "1px solid ".concat("var(--ds-border-accent-blue)"),
    slabColor: "var(--ds-border-accent-blue)"
  },
  statsStyles: {
    color: "var(--ds-text-information)"
  }
}];